const initialState = {
  list: [],
  total: "",
  searchKey: "",
};

const ManageQuestionsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case "MANAGE_ALL_QUESTIONS_RESPONSE":
      return {
        ...state,
        list: [...action.data.list],
        total: action.data.total,
      };

    case "MANAGE_ALL_FEEDBACK_RESPONSE":
      return {
        ...state,
        list: [...action.data.list],
        total: action.data.total,
      };

    default:
      return state;
  }
};

export default ManageQuestionsListReducer;
